module.exports = __webpack_public_path__ + "img/221.48c27653.jpg";